function ArrowUpRightIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M11.1562 3.5V9.1875C11.1562 9.36155 11.0871 9.52847 10.964 9.65154C10.8409 9.77461 10.674 9.84375 10.5 9.84375C10.3259 9.84375 10.159 9.77461 10.0359 9.65154C9.91287 9.52847 9.84373 9.36155 9.84373 9.1875V5.08594L3.96427 10.9643C3.84099 11.0876 3.67378 11.1568 3.49943 11.1568C3.32508 11.1568 3.15787 11.0876 3.03459 10.9643C2.9113 10.841 2.84204 10.6738 2.84204 10.4995C2.84204 10.3251 2.9113 10.1579 3.03459 10.0346L8.91404 4.15625H4.81248C4.63843 4.15625 4.47151 4.08711 4.34844 3.96404C4.22537 3.84097 4.15623 3.67405 4.15623 3.5C4.15623 3.32595 4.22537 3.15903 4.34844 3.03596C4.47151 2.91289 4.63843 2.84375 4.81248 2.84375H10.5C10.674 2.84375 10.8409 2.91289 10.964 3.03596C11.0871 3.15903 11.1562 3.32595 11.1562 3.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ArrowUpRightIcon;
